// abstract-template-box.ts
import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { AuthenticationService } from 'app/auth/service';
import { IntegrationService } from 'app/global/integrations/integrations.service';
import { PipeDriveService } from 'app/global/integrations/pipedrive/pipe-drive.service';
import { IPageableResponse } from 'app/global/pagging.dto';
import { UploadsService } from 'app/global/uploads.service';
import { TemplateForm } from 'app/main/pages/edit-template/edit-template.dto';
import { HelperService } from 'app/main/pages/edit-template/helper.service';
import { DocumentTypeService } from 'app/main/pages/settings/documenttype/document-type.service';
import { TemplateService } from 'app/main/pages/templates/templates.service';
import { AuthFacade } from 'app/store/auth.facade';
import { CrmData } from 'app/store/reducers/auth.reducer';
import { Observable, take } from 'rxjs';
import { SelectTemplateService } from '../select-template.service';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';
import { IDocumentTypesDto } from 'app/main/pages/documents/dto/document-listing.dto';

@Injectable({
    providedIn: 'root'
})

export abstract class AbstractTemplateBox {

  @ViewChild('uploadFileInput') uploadFileInput!: ElementRef;

  public pageBasic = 1;
  public page: number = 1;
  public templateListing: TemplateForm[] = [];
  public formLoader: boolean = false;
  public loading: boolean = false;
  public pagination!: IPageableResponse<TemplateForm>;
  public createingDocument: boolean = false;
  public selectedDocumentType = null;
  public documentTypes: Observable<IDocumentTypesDto[]> = this._sharedStoreFacade$.filterDocumentTypes$;
  public acceptableFiles: string[] = [
    "application/pdf", 
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ];

  constructor(
    protected templateService: TemplateService,
    protected documentTypeService: DocumentTypeService,
    protected selectTemplateService: SelectTemplateService,
    protected _authFacade$: AuthFacade,
    protected pipeDriveService: PipeDriveService,
    protected helperService: HelperService,
    protected integrationService: IntegrationService,
    protected _authenticationService: AuthenticationService,
    protected _uploadingService$: UploadsService,
    protected _sharedStoreFacade$: SharedStoreFacade,
  ) {
    this.selectTemplateService.loading$.subscribe(loading => this.createingDocument = loading);
  }

  async initIntegration() {
    await this.integrationService.setCrmLayout();
    this.getTemplates();
  }

  async getTemplates(page: number = 1, q: string = '') {
    this.loading = true;
    this.page = page;
    this.templateService.publishedOrSharedWith(page, q, { document_type_id: this.selectedDocumentType, language: 'all' }).subscribe({
      next: (templates: IPageableResponse<TemplateForm>) => {
        this.templateListing = templates.data || [];
        this.pagination = templates;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  async goToSendDocument(template: TemplateForm, template_id: number) {
    if (await this.integrationService.setCrmLayout()) {
      this._authFacade$.crmData$.pipe(take(1)).subscribe({
        next: (crmData: CrmData) => {
          const dealData = this.integrationService.getCrmParams(crmData);
          this.integrationService.addPersonsAndRoles(dealData, template, template_id);
        }
      });
    } else {
      this.selectTemplateService.goToSendDocument(template, template_id);
    }
  }

  onFileDropped($event: Event) {
    let files: File[] = [];
    if ($event instanceof Event) {
      const element = $event.target as HTMLInputElement;
      if (element.files) {
        files = Array.from(element.files);
      }
    } else {
      files = $event as unknown as File[];
    }

    this._uploadingService$.uploadFiles(files);
    if ($event instanceof Event) {
      this.uploadFileInput.nativeElement.value = null;
    }
  }

  logoutCrmUser() {
    this._authenticationService.logMeOut();
  }
}
